import { Component, OnInit, inject, output } from '@angular/core';
import { GameFilterService } from '../../../../services/games/game-filter.service';
import { GameCategoryAttrService } from '../../../../services/games/game-category-attribute.service';
import { map } from 'rxjs/operators';
import { FiltersService } from '../../../../services/filters.service';
import { PlatformService } from '../../../../services/platform.service';
import { TranslatePipe } from '../../../../services/translation/translate.pipe';
import { BtnComponent } from '../../../components/btn/btn.component';
import { MultiCheckboxComponent } from '../../../../vendor/multi-checkbox/multi-checkbox.component';
import { ReactiveFormsModule } from '@angular/forms';
import { NgClass, AsyncPipe } from '@angular/common';
import { GameSearchService } from '../../../../services/games/game-search.service';

@Component({
    selector: 'app-games-filter-bar',
    templateUrl: './games-filter-bar.component.html',
    styleUrls: ['./games-filter-bar.component.scss'],
    imports: [ReactiveFormsModule, NgClass, MultiCheckboxComponent, BtnComponent, AsyncPipe, TranslatePipe]
})
export class GamesFilterBarComponent implements OnInit {
  gamesFilter = inject(GameFilterService);
  gamesSearch = inject(GameSearchService);
  private _filter = inject(FiltersService);
  private _platform = inject(PlatformService);

  readonly cancel$ = output<any>();
  readonly submit$ = output<any>();

  public categories$ = this.gamesFilter.categories$.pipe(map(list => this._filter.sortByProp(list, 'label')));

  public providers$ = this.gamesFilter.providers$.pipe(
    map((list: any[]) => {
      return list.filter(e => e.inFilter);
    }),
    map(list => this._filter.sortByProp(list, 'alias')),
  );

  public isFirefox = false;

  ngOnInit(): void {
    if (this._platform.isBrowser) {
      this.isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    }
  }

  onSubmit() {
    this.submit$.emit(true);
  }

  onCancel() {
    this.cancel$.emit(true);
  }
}
